<template>
  <md-card class="md-layout user-list-modal-container">
    <md-card-header class="md-layout-item md-size-100">
      <div class="md-layout header">
        <div class="md-layout-item md-size-90">
          <span class="text">{{ users.length }} Teilnehmer haben sich angeschlossen</span>
        </div>
        <div class="md-layout-item md-size-10" @click="closeModal">
          <md-icon >close</md-icon>
        </div>
      </div>
    </md-card-header>
    <md-card-content class="md-layout-item md-size-100">
      <users-list
          v-if="users.length"
          :friends="users"
      />
      <div v-else>
        Du hast keine Freunde
      </div>
    </md-card-content>
    <md-card-actions class="md-layout-item md-size-100 buttons">
      <md-button md-alignment="right" class="md-alignment-right md-simple md-danger" @click="onCancel()">{{$t('general.cancel')}}</md-button>
    </md-card-actions>
  </md-card>
</template>

<script>
import UsersList from "sports4me-web_components/atomic-design/molecules/users-list";

export default {
  name: "user-list-modal",
  components: { UsersList },
  props: {
    users: {
      type: Array,
      required: false,
      default: new Array()
    }
  },
  methods: {
    closeModal() {
      this.$emit("close");
    },

    onCancel() {
      if(this.cancelButtonFunction) {
        this.cancelButtonFunction()
      } else {
        this.closeModal();
      }
    }
  }

}
</script>

<style lang="scss">
.user-list-modal-container {
  .header {
    padding: 10px 0;
    .text {
      font-size: 20px;
      font-weight: 500;
    }
  }

  .buttons {
    padding-top: 0;
    display: flex;
    button {
      font-size: 1rem;
    }
  }
}
</style>